<app-banner></app-banner>
@if (data.CLOCK_START < today){
    <div class="united-blue-new">
        <app-countdown-clock [targetDate]="data.CLOCK_END" ></app-countdown-clock>
    </div>

}

<section class="main-section confirmation white-bg">
    <div class="width-container">
        <h2 id="confirm-header" tabindex="-1" class="no-outline" [innerHtml]="'CONFIRM.HEAD' | translate:data"></h2>
        <p [innerHtml]="'CONFIRM.DESC' | translate:data"></p>
        <div class="bonus-section">
            <div>
                <h3 [innerHtml]="'CONFIRM.BONUS_SECTION.BONUS_1' | translate:data"></h3>
                <p [innerHtml]="'CONFIRM.BONUS_SECTION.BONUS_1_DESC' | translate:data"></p>
            </div>
            <div>
                <p [innerHtml]="'CONFIRM.BONUS_SECTION.OR' | translate:data"></p>
                <p [innerHtml]="'CONFIRM.BONUS_SECTION.OR_2' | translate:data"></p>
            </div>
            <div>
                <h3 [innerHtml]="'CONFIRM.BONUS_SECTION.BONUS_2' | translate:data"></h3>
                <p [innerHtml]="'CONFIRM.BONUS_SECTION.BONUS_2_DESC' | translate:data"></p>
            </div>
        </div>
        <p [innerHtml]="'CONFIRM.REGISTRATION_DATE' | translate:data"></p>
        <p [innerHtml]="'CONFIRM.FOOTNOTE' | translate"></p>
    </div>
</section>